import {Event} from "./event";
import {last} from "lodash";

class GroupEvent extends Event {
  constructor(public readonly groupId: any, sender: any) {
    super(sender);
  }
}

class AppearanceEvent extends GroupEvent {

  isRoot?: boolean;

  constructor(public readonly groupId: any, public readonly groupPath: any, sender: any) {
    super(groupId, sender);
    this.isRoot = (last(groupPath) as any).isRoot;
  }
}

export class RemoveEvent extends AppearanceEvent {
}

export class LeaveEvent extends AppearanceEvent {
}

export class CreateEvent extends AppearanceEvent {
}

export class JoinEvent extends AppearanceEvent {
}

export class AcceptEvent extends AppearanceEvent {
}

export class SelectEvent extends GroupEvent {
  constructor(groupId, public groupPath: any, sender) {
    super(groupId, sender);
  }
}

export class DeclineEvent extends GroupEvent {
}

export class EditEvent extends GroupEvent {
  constructor(groupId, public data: any, sender) {
    super(groupId, sender);
  }
}

export class GrantAdminRightsEvent extends GroupEvent {
}

export class RevokeAdminRightsEvent extends GroupEvent {
}

export class RequestAffiliationEvent extends GroupEvent {
}
